import { parseJSON } from '@gem/utils';

import { IStorageSessionCredentials } from '../../remote-storage';
import { localStorageInstance } from '../instances/localStorageInstance';

const KEY_NAME = 'storage-session-credentials-key';

export const set = (credentials: IStorageSessionCredentials): void => {
  localStorageInstance.setItem(KEY_NAME, JSON.stringify(credentials));
};

export function get(): IStorageSessionCredentials | null {
  const credentialsStorageData = localStorage.getItem(KEY_NAME);

  if (!credentialsStorageData) {
    return null;
  }

  try {
    return parseJSON<IStorageSessionCredentials>(credentialsStorageData, true);
  } catch {
    return null;
  }
}

export function remove(): void {
  localStorageInstance.removeItem(KEY_NAME);
}
